/**
 * Colours the page draws that the design does not give, each a stand-in for the designer and kept out of the token
 * table, which holds the design's values only. Help's colour (ADR-068's amendments "Global, Trade and Help", item 8,
 * and "scope tabs, and Help's icon", item 1): the client's `chat.css` repeats it as `--ot-chat-help-standin` for
 * Help's lines, and the UI atlas build's palette takes it under `HELP_STANDIN_NAME` to paint Help's icon; a test
 * holds the three equal. Relic's colour (ADR-125 decision 1.3): the client's item slot writes it on a Relic
 * slot as `--ot-item-slot-edge`, the colour of its ring, and the item card takes it for its edge, band, burst, name and
 * sparks (P2.8-T46).
 */

/**
 * The palette name Help's icon grid paints its glyph in.
 */
export const HELP_STANDIN_NAME = "chat-help-standin";

/**
 * Help's stand-in colour: a cyan that reads at about 10 to 1 on the chat log's surface.
 */
export const HELP_STANDIN_COLOUR = "#68d8d8";

/**
 * Relic's stand-in colour: a teal no other rarity uses, about 10 to 1 on the item card's `ink-700`.
 */
export const RELIC_STANDIN_COLOUR = "#3fcfb0";
